



























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { auth } from '@/firebaseConfig.ts';
import { User } from '../../types';

@Component
export default class Login extends Vue {
  email: string = '';

  password: string = '';

  error: string = '';

  busy: boolean = false;

  async login() {
    this.error = '';
    this.busy = true;
    try {
      const data = await auth.signInWithEmailAndPassword(
        this.email,
        this.password,
      );
      const currentUser = auth.currentUser;
      if (currentUser) {
        const { claims } = await currentUser.getIdTokenResult();
        console.log('Claims', claims);
        if (!claims.role) {
          auth.signOut();
          this.error = 'You do not have access rights.';
          return;
        }
        const user = {
          name: currentUser.displayName,
          email: currentUser.email,
          role: claims.role,
          companyId: claims.companyId,
        } as User;
        this.$store.dispatch('setUser', user);
        if (user.role == 'admin') this.$router.replace({ path: '/companies' });
        else if (user.role == 'company') this.$router.replace({ path: '/' });
      }
    } catch (err) {
      this.error = err.message;
    } finally {
      this.busy = false;
    }
  }
}
